/*
 * @Author: your name
 * @Date: 2021-10-19 10:27:23
 * @LastEditTime: 2022-07-14 10:26:15
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\api\orderApi\internal.js
 */
import { generate } from '@/utils/request';

const config = {
  prefix: '/third-adapter/v1/{organizationId}',
  items: [
    // 创建第三方订单头
    { key: 'addThirdOrderByHand', url: '/third-order/create', method: 'POST' },
    // 获取第三方订单列表
    { key: 'getThirdOrderPage', url: '/third-order/page', method: 'POST',loadingHide: true, },
    // 获取第三方订单列表 POST /v1/{organizationId}/third-order/csgPage
    { key: 'getCSGThirdOrderPage', url: '/third-order/csgPage', method: 'POST',loadingHide: true, },
    // 卡单
    { key: 'getThirdOrderPageProcess', url: '/third-order/pageProcess', method: 'POST' },
    // 批量恢复 ==>>>   post /v1/{organizationId}/third-order/resumeOrders
    { key: 'doThirdOrderResumeOrders', url: '/third-order/resumeOrders', method: 'POST' },
    // 获取第三方订单详情
    { key: 'getThirdOrderDetail', url: '/third-order/detail', method: 'GET' },
    // 获取第三方订单详情页图片 get /v1/{organizationId}/handheld/getDeliveryImg  ==> 马光浩
    { key: 'getThirdOrderDetailImg', url: '/handheld/getDeliveryImg?outOrderNo={outOrderNo}', method: 'GET' },
    // 已完成订单==>>>创建退货单 get /v1/{organizationId}/third-order/createReturnOrder  ==> 马光浩
    { key: 'overOrderCreateReturnOrder', url: '/third-order/createReturnOrder?outerOrderNo={outerOrderNo}', method: 'GET' },
    // 退货单详情==>>>下载      get /v1/{organizationId}/third-order/createAuPostReturnOrder  ==> 马光浩
    { key: 'createAuPostReturnOrder', url: '/third-order/createAuPostReturnOrder?outerOrderNo={outerOrderNo}', method: 'GET' },
    // 第三方文件上传 POST /v1/{organizationId}/handheld/third/multipart  ==> 马嘉祺
    { key: 'uploadThirdOrderFile', url: '/handheld/third/multipart', method: 'POST' },
    // 外部订单买家及收货信息
    { key: 'modifyThirdOrder', url: '/third-order/modify', method: 'POST' },
    // 外部订单加急  POST /v1/{organizationId}/third-order/order-urgent ==> 马嘉祺
    { key: 'urgentThirdOrder', url: '/third-order/order-urgent?outerOrderNo={outerOrderNo}', method: 'POST' },
    // 暂停启动
    { key: 'pauseOrResumeOrder', url: '/third-order/pauseOrResumeOrder', method: 'POST' },
    // 售后
    { key: 'pageList', url: '/returnInfo/pageList', method: 'get' },
    { key: 'add', url: '/returnInfo/add', method: 'post' },
    { key: 'edit', url: '/returnInfo/edit', method: 'post' },
    { key: 'addByWarehouse', url: '/returnInfo/addByWarehouse', method: 'post' },
    { key: 'confirm', url: '/returnInfo/confirm', method: 'post' },
    { key: 'delete', url: '/returnInfo/delete/{returnInfoId}', method: 'get' },
    { key: 'detail', url: '/returnInfo/detail/{returnInfoId}', method: 'get' },
    { key: 'operateLogs', url: '/returnInfo/operateLogs/{returnInfoId}', method: 'get' },


    { key: 'thirdAdapter', url: '/batch/getStockList', method: 'POST' },
    { key: 'selectSkuCodeBatch', url: '/batch/selectSkuCodeBatch', method: 'POST' },
    { key: 'getThirdItemBatchPage', url: '/third-order/getThirdItemBatchPage', method: 'POST' },
    
    // 库存变动 列表页  post /v1/{organizationId}/stockMove/list
    { key: 'getStockMovePageList', url: '/stockMove/list', method: 'POST' },
    // 库存变动 导出    post /v1/{organizationId}/stockMove/export
    { key: 'exportStockMovePageList', url: '/stockMove/export', method: 'POST' },
    // 等待发货 修改 其他相关文件    put /v1/{organizationId}/third-order/updateOrderMaterial
    { key: 'updateOrderMaterial', url: '/third-order/updateOrderMaterial', method: 'PUT' },
  ],
};

export default {
  ...generate(config),
};
